import { API } from "@/assets";

// XP / progression helpers shared by every Medusa section.
export async function grantXP(section, amount, reason, refId = "") {
  try {
    const r = await fetch(`${API}/players/xp`, {
      method: "POST", credentials: "include", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ section, amount: Math.round(amount), reason, ref_id: refId }),
    });
    if (!r.ok) return null; // signed-out guests play without saving
    const d = await r.json();
    window.dispatchEvent(new CustomEvent("medusa:xp"));
    return d;
  } catch { return null; }
}

export async function saveProgress(refType, refId, score, accuracy) {
  try {
    await fetch(`${API}/players/progress`, {
      method: "POST", credentials: "include", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ref_type: refType, ref_id: refId, score: Math.round(score), accuracy }),
    });
  } catch { /* guests play without saving */ }
}

// mirror of the backend triangular curve for progress bars
export function levelProgress(xp) {
  let level = 1, needed = 100, total = 0;
  while (xp >= total + needed) { total += needed; level += 1; needed += 100; }
  return { level, into: xp - total, needed };
}

export const SECTION_LABELS = {
  piano: "Piano Mastery",
  academy: "Production Academy",
  arcade: "Arcade Chamber",
  snakepit: "Snake Pit",
  studio: "Free Play Studio",
};
